import React from "react";
import { Tooltip } from "antd";

const RelatesToComponent = ({ item, productCode }) => {
  const { patient, careManager } = item;

  const patientHref =
    productCode === "CLEARCARE" && patient.clearCareClientId
      ? `/clients/${patient.clearCareClientId}`
      : `/patients/edit?id=${patient?.id}`;
  const patientName = `${patient?.firstName} ${patient?.lastName}`;

  const careManagerHref = `/members/edit?id=${careManager?.id}`;
  const careManagerName = careManager?.fullName;

  return (
    <>
      <div onClick={(e) => e.stopPropagation()} className="relatesto_layout">
        {patient && (
          <a
            href={patientHref}
            style={{ color: "#1890ff", textDecoration: "underline" }}
          >
            <div className="__relatesto_container">
              <Tooltip title="Patient">
                <div className="icon">
                  <div>P</div>
                </div>
              </Tooltip>
              <div className="name">{patientName}</div>
            </div>
          </a>
        )}
        {careManager && (
          <a
            href={careManagerHref}
            style={{ color: "#1890ff", textDecoration: "underline" }}
          >
            <div className="__relatesto_container">
              <Tooltip title="Care Manager">
                <div className="icon">
                  <div>C</div>
                </div>
              </Tooltip>
              <div className="name">{careManagerName}</div>
            </div>
          </a>
        )}
      </div>
      <style>{`
        .relatest_layout {
          display: flex;
          flex-direction: column;
        }
        .__relatesto_container {
          display: flex;
          flex-direction: row;
          margin: 0.25em;
          cursor: pointer;
        }
        .name:hover{
          text-decoration: underline;
        }
        .icon {
          display: flex;
          border-radius: 0.25em;
          padding: 0em 0.65em;
          background-color: #EFF6F9;
          text-transform: uppercase;
          font-size: 0.8em;
          align-items: center;
          justify-content: center;
          color: #1270D6;
          margin-right: 0.5em;
          font-weight: 600;
        }
        .name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #e17e25;
        }
      `}</style>
    </>
  );
};

export default RelatesToComponent;
